import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { createApp } from '../../store/actions/appAction';
import UploadImage from "../../components/uploadImage";
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { Container, Typography, Grid, Card, CardContent, Box } from '@material-ui/core';
import { MdAdd } from "react-icons/md";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));



const EditTemplate = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const history = useHistory()
    const [ input, setInput ] = useState({
        appName: '',
        description: '',
        redirectUrlApp: '',
        image: ''
    })

    const handleNewTemplate = () => {
      history.push('/app')
    }
        
    return (
        <React.Fragment>
        <Header page='CreateApp'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
        <Typography align="center" color="textPrimary" spacing={4} gutterBottom className="mt-30 reguler font-size-28">
         edit template
        </Typography>
        </Grid>
      </React.Fragment>     
    )
}

export default EditTemplate
